import React from 'react';
import styled from 'styled-components';

import { createCollecticon } from '../collecticon-creator';

export const CollecticonEnvelope = styled(
  createCollecticon((props) => (
    <svg {...props}>
      <title>{props.title || 'envelope icon'}</title>
      <path d='M0,6v8h16V6l-8,5L0,6z M0,2v2l8,5l8-5V2H0z' />
    </svg>
  ))
)`
  /* icons must be styled-components */
`;
